import React, { useState, useEffect } from "react";

import { useLocation } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import { form } from "../Service/Api";
import { getHeader } from "../config";
import PageTitle from "../Component/PageTitle";
const ContactUs = () => {
  const homeMenu = [
    { label: "Contact Us", link: "/contactUs" },
    { label: "Feedback", link: "/contactUs#feedback" },
  ];
  //const location = useLocation();

  // useEffect(() => {
  //   if (location.hash) {
  //     const el = document.querySelector(location.hash);
  //     if (el) {
  //       setTimeout(() => {
  //         el.scrollIntoView({ behavior: "smooth" });
  //       }, 300); // slight delay to ensure DOM is ready
  //     }
  //   }
  // }, [location]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.message
    ) {
      document.querySelector(".primary-alert").innerHTML =
        "<p>Please fill all the fields.</p>";
      return;
    }

    try {
      const type = "dif";
      const { header } = getHeader(); // Retrieve headers from getHeader function
      const response = await form(formData, header, type); // Pass the headers to the form function
      console.log("Form submitted successfully", response);
      document.querySelector(".primary-alert").innerHTML =
        "<p>Your Form Submitted Successfully.</p>";
      document.querySelectorAll(".input, textarea").forEach((input) => {
        input.value = "";
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-contact.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page contactUs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Contact Us"
                breadEnd="Contact Us"
                breadMid="Contact Us"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>
                Lotus Valley International School, Gurgaon is located just 10
                minutes drive from NH-8. Easily accessible from Delhi, the
                location is well connected by excellent roads and Highways that
                ensure a safe and comfortable journey for your child.
              </p>
              <iframe
                width="100%"
                height="250"
                title="contact Us"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                className="float-end"
                marginwidth="0"
                src="https://maps.google.co.in/maps/ms?msa=0&amp;msid=210323678924138221658.0004eed2ed9e65033ed62&amp;ie=UTF8&amp;t=m&amp;ll=28.416579,77.068491&amp;spn=0.013211,0.018239&amp;z=15&amp;output=embed"
              ></iframe>
              <p className="color-green">Lotus Valley International School</p>
              <p>
                M-Block, South City-II,
                <br /> Nirvana Country,
                <br /> Sector-50 (Behind North Close),
                <br /> Gurgaon-122018
                <br /> +91-9650544997, 0124-4936900
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p className="color-green">Contact Details For Admission</p>
              <div className="table-responsive">
                <table className="remove-bg-color">
                  <tr>
                    <td>Front Desk/Admission Enquiries </td>
                    <td>
                      <a href="tel:0124-4936900">0124-4936900</a>,{" "}
                      <a href="tel:9650544997">9650544997</a>
                    </td>
                  </tr>
                  <tr>
                    <td>Transport Enquiries </td>
                    <td>9910220942</td>
                  </tr>
                  <tr>
                    <td>E-Mail </td>
                    <td>
                      <span>
                        <a
                          href="mailto:director@lotusvalleygugaon.com"
                          target="_blank"
                        >
                          director@lotusvalleygugaon.com
                        </a>
                        <br />
                        <a
                          href="mailto:principal@lotusvalleygurgaon.com"
                          target="_blank"
                        >
                          principal@lotusvalleygurgaon.com
                        </a>
                        <br />
                       
                        <a
                          href="mailto:transport@lotusvalleygurgaon.com"
                          target="_blank"
                        >
                          {" "}
                          transport@lotusvalleygurgaon.com
                        </a>
                        <br />
                        <a
                          href="mailto: admissions@lotusvalleygurgaon.com"
                          target="_blank"
                        >
                          {" "}
                          admissions@lotusvalleygurgaon.com
                        </a>
                        <br />
                        <a
                          href="mailto:accounts@lotusvalleygurgaon.com"
                          target="_blank"
                        >
                          {" "}
                          accounts@lotusvalleygurgaon.com
                        </a>
                        <br></br>
                         <a
                          href="mailto:info@lotusvalleygurgaon.com"
                          target="_blank"
                        >
                          info@lotusvalleygurgaon.com
                        </a>
                        
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Website</td>
                    <td>
                      <span>
                        <Link to="www.lotusvalleygurgaon.com">
                          www.lotusvalleygurgaon.com
                        </Link>
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
              <p className="partnershipitalic">
                <i>
                  (Note: Any change in schedule shall be notified by the
                  Director)
                </i>
              </p>
              <div className="table-responsive">
                <table className="remove-bg-color">
                  <tr>
                    <td>Director</td>
                    <td>Ms. Anita Malhotra </td>
                    <td>
                      <Link to="mailto:director@lotusvalleygugaon.com">
                        director@lotusvalleygugaon.com
                      </Link>{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Principal </td>
                    <td>Ms Ruchi Joshi </td>
                    <td>
                      <Link to="mailto:principal@lotusvalleygurgaon.com">
                        principal@lotusvalleygurgaon.com
                      </Link>{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Vice Principal (IX - XII) </td>
                    <td>Ms. Monica Jasrotia</td>
                    <td>
                      <Link to="mailto:vpsr@lotusvalleygurgaon.com">
                        vpsr@lotusvalleygurgaon.com
                      </Link>{" "}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid dark-section" id="feedback">
          <div className="row">
            <div className="col-md-12">
              <div className="form-title">
                <PageTitle pageTitle="Feedback" />
              </div>
              <div className="form-blk">
                <form onSubmit={handleSubmit}>
                  <div>
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      onChange={handleChange}
                      value={formData.name}
                    ></input>
                  </div>
                  <div>
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      value={formData.email}
                    ></input>
                  </div>
                  <div>
                    <label>Contact No</label>
                    <input
                      type="tel"
                      name="phone"
                      onChange={handleChange}
                      value={formData.phone}
                    ></input>
                  </div>
                  <div>
                    <label>Message</label>
                    <textarea
                      onChange={handleChange}
                      name="message"
                      value={formData.message}
                    ></textarea>
                  </div>
                  <div className="submit">
                    <input type="submit" value="Submit" />
                  </div>
                  <div className="primary-alert"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ContactUs;
